// Centralised WhatsApp helpers — single source of truth for the number & links.

export const WHATSAPP_NUMBER = "33776069799";

/** Build a wa.me link with a pre-encoded message. */
export function whatsappLink(message) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

/** Open WhatsApp in a new tab with the given message. */
export function openWhatsApp(message) {
  const url = whatsappLink(message);
  window.open(url, "_blank", "noopener,noreferrer");
}

/**
 * Build the "demande de réservation" message from the cart.
 * @param {Array} items   cart items { label, price, quantity }
 * @param {number} total  estimated total in euros
 * @param {object} contact { name, phone, address }
 */
export function buildCartMessage(items, total, contact = {}) {
  const lines = items.map((it) => {
    const qty = it.quantity > 1 ? `${it.quantity}× ` : "";
    const price = it.price > 0 ? ` (${it.price * it.quantity} €)` : " (sur devis)";
    const meta = it.meta ? ` — ${it.meta}` : "";
    return `• ${qty}${it.label}${price}${meta}`;
  });

  return [
    "Bonjour,",
    "Je souhaite réserver :",
    ...lines,
    "",
    `Total estimé : ${total} €`,
    `Nom : ${contact.name || ""}`,
    `Téléphone : ${contact.phone || ""}`,
    `Adresse : ${contact.address || ""}`,
    "",
    "Merci.",
  ].join("\n");
}
